export class GameObjectAttributes {
  type: string;
  shakes: boolean;
  mass: number;
  drops: string[];
  health: integer;
  aggressive: boolean;
  allowRotation: boolean;
  token?: string;
  constructor(
    type: string = 'item',
    shakes: boolean = true,
    mass: number = -1,
    health: integer = 2,
    drops: string[] = [],
    aggressive: boolean = false,
    allowRotation: boolean = true,
    token?: string
  ) {
    this.type = type;
    this.shakes = shakes;
    this.health = health;
    this.drops = drops;
    this.mass = mass;
    this.aggressive = aggressive;
    this.allowRotation = allowRotation;
    this.token = token;
  }
}
